import { render, staticRenderFns } from "./MyChartDoughnut.vue?vue&type=template&id=7ec09922&"
import script from "./MyChartDoughnut.vue?vue&type=script&lang=js&"
export * from "./MyChartDoughnut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports